/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SalestrakIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="salestrak"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M1 6L5.5 6L23 18L18.5 18L1 6Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M16 17.5L3.25 17.5L10 13.5L16 17.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M8 6.5L20.75 6.5L14 10.5L8 6.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
